module.exports = __webpack_public_path__ + "img/form_m_pdf_logo.acf4352a.png";